import React, { useRef } from 'react';

/**
 * DraggableList - Drag & Drop ordinabile (solo PC) per React Native Web
 * @param {Array} items - array di oggetti { name: string }
 * @param {function} onMove - funzione (fromIdx, toIdx) => void
 * @param {function} renderItem - funzione (item, idx, isDragging, dragHandleProps) => ReactNode
 */
export default function DraggableList({ items, onMove, renderItem }) {
  const dragItem = useRef();
  const dragOver = useRef();

  function onDragStart(idx) {
    dragItem.current = idx;
  }
  function onDragEnter(idx) {
    dragOver.current = idx;
  }
  function onDragEnd() {
    if (
      dragItem.current !== undefined &&
      dragOver.current !== undefined &&
      dragItem.current !== dragOver.current
    ) {
      onMove(dragItem.current, dragOver.current);
    }
    dragItem.current = undefined;
    dragOver.current = undefined;
  }

  return (
    <div>
      {items.map((item, idx) => (
        <div
          key={idx}
          draggable
          onDragStart={() => onDragStart(idx)}
          onDragEnter={() => onDragEnter(idx)}
          onDragEnd={onDragEnd}
          style={{
            opacity: dragItem.current === idx ? 0.4 : 1,
            transition: 'opacity 0.2s',
            cursor: 'grab',
            marginBottom: 8,
          }}
        >
          {renderItem(item, idx, dragItem.current === idx, {
            style: { cursor: 'grab' },
          })}
        </div>
      ))}
    </div>
  );
}
